<template>
  <div>
    <!-- 协议 -->
    <div class="content">
      <div class="main" v-html="agreement">
        <!-- <Privacypolicy></Privacypolicy> -->
      </div>
    </div>
  </div>
</template>
<script>
  import Privacypolicy from "@/components/Privacypolicy.vue";
  export default {
    name: "about",
    components: {
      Privacypolicy,
    },
    data() {
      return {
        agreement: '',
      }
    },
    mounted() {
      window.scrollTo(0, 0);
      this.$fetchql.japi("baseclientagreement/getinfo?agreementCode=H5YSZC").then((result) => {
        if (result.code == 200) {
          this.agreement = result.data.content
        }
      });
    },
  };

</script>

<style scoped="scoped">
  a {
    word-break: break-all;
  }

  a:link {
    color: #83878b;
  }

  /* 未被访问的链接 */
  a:visited {
    color: #83878b;
  }

  /* 已被访问的链接 */
  a:hover {
    text-transform: uppercase;
  }

  /* 鼠标指针移动到链接上 */

  li {
    list-style: none;
  }

  .intro {
    color: #bdbdbd;
    font-size: 12px;
    margin-bottom: 12px;
  }

  .topTitle {
    color: #f5f4f9;
    font-size: 17px;
    font-weight: bold;
    text-align: center;
    display: inline-block;
    margin-bottom: 25px;
  }

  .topTitle img {
    width: 47px;
    height: 47px;
    object-fit: cover;
    display: inline-block;
    vertical-align: middle;
  }

  .main {
    padding: 30px 15px;
    overflow: hidden;
    background-color: #0c0c0c;
    margin: 34px 16px;
    box-shadow: 0px 1px 2px 0px rgba(0, 0, 0, 0.5);
    border-radius: 4px;
    margin-bottom: 40px;
    font-size: 12px;
    color: #8d8f9f;
    line-height: 1.75;
    text-align: left;
  }

  .main h5 {
    font-size: 12px;
    font-weight: normal;
  }

  .privacy-tableOfContents,
  .privacy-content {
    color: #83878b;
    font-size: 12px;
  }

  .privacy-tableOfContents ul li {
    display: flex;
    align-items: center;
  }

  .privacy-tableOfContents li span {
    text-align: right;
  }

  .privacy-tableOfContents li p {
    margin-left: 8px;
    text-align: left;
  }

  .privacy-content ul li .lf {
    text-align: right;
  }

  .privacy-content ul li .rt {
    text-align: left;
  }

  .bold {
    /* font-weight: bolder; */
  }

</style>
<style>
  p {
    margin: 0;
    padding: 0;
  }

  * {
    margin: 0;
    padding: 0;
  }

</style>



// WEBPACK FOOTER //
// src/views/privacyPolicy.vue